import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box, Paper } from '@mui/material';
import chartSx from './Chart.styles';
import { useTheme } from '@mui/material/styles';

const CodeDefinitions = ({ title, symbolType }) => {
    const codesBuccal = useSelector((state) => state.chart.chart_symbols_buccal);
    const codesOcclusal = useSelector((state) => state.chart.chart_symbols_occlusal);
    const allCodes = useSelector((state) => state.chart.symbols);

    const codes = useMemo(() => {
        return [...(codesBuccal || []), ...(codesOcclusal || [])];
    }, [codesBuccal, codesOcclusal]);

    const allCodesById = useMemo(() => {
        if (!allCodes) {
            return {};
        }

        return allCodes.reduce((acc, code) => {
            acc[code.symbol_id] = code;
            return acc;
        }, {});
    }, [allCodes]);

    const theme = useTheme();
    const sx = chartSx(theme);

    let filtered = codes
            .filter((code) => code.symbol_type === symbolType)
            .map((code) => {
                const abbreviation = allCodesById[code.symbol_id]?.symbol_abbreviation ?? code.render_value;
                return `${abbreviation} - ${code.symbol_name}`;
            }),
        definitions = [...new Set(filtered)];

    return (
        <Paper elevation={2} sx={{ mt: 2, p: 1, pt: 0, ...(sx.bottomBoxes || {}) }}>
            <div>
                <Box
                    sx={{
                        pt: 1,
                        position: 'sticky',
                        top: 0,
                        zIndex: 1,
                        backgroundColor: 'background.paper',
                        pb: 0.5,
                    }}
                >
                    <strong>{title}</strong>
                </Box>
                <ul style={{ marginTop: '8px' }}>
                    {definitions.map((def, index) => (
                        <li key={index}>
                            <span>{def}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </Paper>
    );
};

export default CodeDefinitions;
